import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Clock, Leaf } from 'lucide-react';
import l from "../assets/sde.svg";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#004534] to-[#0C6951] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src={l}
                alt="Shri Durga Enterprises"
                className="h-16 w-16 object-contain bg-white rounded-lg p-2"
              />
              <div>
                <h3 className="text-xl font-bold">Shri Durga Enterprises</h3>
                <p className="text-sm text-green-200">Solar Solutions</p>
              </div>
            </div>
            <p className="text-sm text-gray-200 leading-relaxed">
              Leading solar energy solutions provider with 20+ years of experience. 
              Powering a sustainable future across Karnataka, Maharashtra, and Goa.
            </p>
            <div className="flex items-center space-x-2 text-green-300">
              <Leaf className="w-5 h-5" />
              <span className="text-sm font-semibold">2,75000 Tons CO₂ Saved</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-green-400 pb-2 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Products', 'Services', 'Projects', 'Testimonials', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-')}`}
                    className="text-gray-200 hover:text-green-300 transition-colors duration-300 text-sm flex items-center group"
                  >
                    <span className="w-0 group-hover:w-2 h-0.5 bg-green-400 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-green-400 pb-2 inline-block">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-sm">
                <MapPin className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-200">
                  Shop No. G3/1, Sairaj Empire, Roy Rd, Shivaji Colony, 
                  Tilakwadi, Belagavi, Karnataka 590006
                </span>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Phone className="w-5 h-5 text-green-400" />
                <a href="tel:07026303999" className="text-gray-200 hover:text-green-300 transition-colors">
                  070263 03999
                </a>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Mail className="w-5 h-5 text-green-400" />
                <a href="mailto:info@shridurgasolar.com" className="text-gray-200 hover:text-green-300 transition-colors">
                  info@sdesolarenergies.com
                </a>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Clock className="w-5 h-5 text-green-400" />
                <span className="text-gray-200">Mon - Sat: 10:00 AM - 8:00 PM</span>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-bold mb-6 border-b-2 border-green-400 pb-2 inline-block">
              Service Areas
            </h4>
            <ul className="space-y-3 mb-6">
              {['Belagavi', 'Karnataka', 'Goa'].map((area) => (
                <li key={area} className="text-sm text-gray-200 flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-3"></span>
                  {area}
                </li>
              ))}
            </ul>

            {/* Social Links */}
            <div>
              <h5 className="text-sm font-semibold mb-3">Follow Us</h5>
              <a
                href="https://www.instagram.com/shri_durga_enterprises_/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-white/10 hover:bg-white/20 px-4 py-2 rounded-lg transition-colors duration-300"
              >
                <Instagram className="w-5 h-5 text-green-300" />
                <span className="text-sm">@shridurgaenterprises</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center gap-4">
            
            {/* Left */}
            <p className="text-sm text-gray-300 text-center md:text-left md:w-1/3">
              © {new Date().getFullYear()} Shri Durga Enterprises. All rights reserved.
            </p>

            {/* Middle */}
            <p className="text-sm text-gray-300 text-center md:w-1/3">
              Powering a Sustainable Future | 5000+ Projects Completed
            </p>

            {/* Right */}
            <p className="text-sm text-center md:text-right md:w-1/3">
              <span className="text-gray-400">Developed By </span>
              <a
                href="https://x7ittechnologies.com"
                className="text-orange-500 hover:text-blue-500 font-medium transition-colors duration-300"
                target='blank'
              >
                X7 IT Technologies
              </a>
            </p>

          </div>
        </div>
      </div>


      {/* Solar Grid Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="solar-grid-footer w-full h-full"></div>
      </div>

      <style jsx>{`
        .solar-grid-footer {
          background-image: 
            linear-gradient(90deg, rgba(255, 255, 255, 0.5) 1px, transparent 1px),
            linear-gradient(rgba(255, 255, 255, 0.5) 1px, transparent 1px);
          background-size: 60px 60px;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
